import { render, staticRenderFns } from "./KeystoneMarketResearchPage.vue?vue&type=template&id=27feb65a&"
import script from "./KeystoneMarketResearchPage.vue?vue&type=script&lang=js&"
export * from "./KeystoneMarketResearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports